__turbopack_context__.v({
  "accordionSlideOverwrite": "toggleGroup-module-scss-module__PoFZPG__accordionSlideOverwrite",
  "fadeIn": "toggleGroup-module-scss-module__PoFZPG__fadeIn",
  "fadeOut": "toggleGroup-module-scss-module__PoFZPG__fadeOut",
  "scaleIn": "toggleGroup-module-scss-module__PoFZPG__scaleIn",
  "scaleOut": "toggleGroup-module-scss-module__PoFZPG__scaleOut",
  "toggle": "toggleGroup-module-scss-module__PoFZPG__toggle",
  "toggleGroup": "toggleGroup-module-scss-module__PoFZPG__toggleGroup",
  "zoomIn": "toggleGroup-module-scss-module__PoFZPG__zoomIn",
  "zoomOut": "toggleGroup-module-scss-module__PoFZPG__zoomOut",
});
